/**
 * Okta-specific Auth Hook
 */
import { useOktaAuth } from '@okta/okta-react';

export const useAuthOkta = () => {
  const { authState, oktaAuth } = useOktaAuth();
  
  return {
    isAuthenticated: authState?.isAuthenticated || false,
    authState: authState,
    authInstance: oktaAuth,
    user: null,
    authenticate: async () => {
      if (!authState?.isAuthenticated) {
        await oktaAuth.signInWithRedirect();
      }
    }
  };
};
